/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Student_Delete_ConfirmInputs */

const en_student_delete_confirm = /** @type {(inputs: Student_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name}? This also removes their lessons and payments. This can't be undone.`)
};

const he_student_delete_confirm = /** @type {(inputs: Student_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`למחוק את ${i?.name}? פעולה זו תמחק גם את השיעורים והתשלומים שלו. לא ניתן לבטל.`)
};

/**
* | output |
* | --- |
* | "Delete {name}? This also removes their lessons and payments. This can't be undone." |
*
* @param {Student_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_delete_confirm = /** @type {((inputs: Student_Delete_ConfirmInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_Delete_ConfirmInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_delete_confirm(inputs)
	return he_student_delete_confirm(inputs)
});